module.exports = __webpack_public_path__ + "static/media/check_circle-24px.fc1f01e6.svg";